import React from 'react'
import Header from './Header'
import Vision from './Vision'
import MessageFromFounder from './MessageFromFounder'
import MeetOurTeam from './MeetOurTeam'
import Footer from './Footer'

const AboutUsPage = () => {
  return (
    <div>
        <Header />
        <Vision />
        <MessageFromFounder />
        <MeetOurTeam />
        <Footer />
        
    </div>
  )
}

export default AboutUsPage